export const DEFAULT_STEP = 1;
export const DEFAULT_MIN = 1900;
export const DEFAULT_MAX = 2018;
export const URL_PARAMETER_MIN = ['yearFrom', 'minYear'];
export const URL_PARAMETER_MAX = ['yearTo', 'maxYear'];
